import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {MenuItem} from "primeng/api";
import {EuRegistrationStatusInternal} from "../../../../enum/eu-registration-status-internal.enum";
import {EuRegistrationService} from "../../../../service/api/eu-registration.service";
import {
    OverviewStatisticsBaseComponent
} from "../../../../../../core/shared/overview/overview-statistics-base.component";
import {WidgetData} from "../../../../../../core/shared/widget/widget-data";
import {OverviewDto} from "../../../../../../core/shared/overview/dto/overview.dto";
import {MvsCoreService} from "../../../../../../core/shared/service/mvs-core.service";
import {ObjectRequestListGroupBy} from "../../../../../../core/shared/dto/object/request/object-request-list-group-by";
import {
    ObjectRequestListAttribute
} from "../../../../../../core/shared/dto/object/request/object-request-list-attribute";
import {
    DtoListAttributeRequestAggregateEnum
} from "../../../../../../core/shared/dto/enum/dto-list-attribute-request-aggregate.enum";
import {
    ObjectRequestEntityProcessingTypeEnum
} from "../../../../../../core/shared/dto/object/request/object-request-entity-processing-type.enum";
import {WidgetFactory} from "../../../../../../core/shared/widget/service/widget.factory";
import {WidgetDataParam} from "../../../../../../core/shared/widget/widget-data-param";
import {Sorting} from "../../../../../../core/shared/misc/sorting";


@Component({
    selector: 'eu-statistics',
    templateUrl: 'eu-statistics.component.html',
    standalone: false
})
export class EuStatisticsComponent extends OverviewStatisticsBaseComponent implements OnInit, OnChanges, OnDestroy {

    pending: number = 0;
    processed: number = 0;
    inProcess: number = 0;
    unfinished: number = 0;


    registrationHistoryWidget: WidgetData;
    recentlyAddedRegistrationsWidget: WidgetData;
    registrationGroupByGenderWidget: WidgetData;
    registrationGroupByStatusWidget: WidgetData;

    items: MenuItem[] | undefined;

    home: MenuItem | undefined;
    overviewDto: OverviewDto[];

    constructor(
        protected registrationService: EuRegistrationService,
        private router: Router,
        protected route: ActivatedRoute,
        protected coreService: MvsCoreService) {
        super(route, coreService)
    }

    ngOnInit(): void {


        this.items = [
            {label: 'End User Module'},
        ];

        this.home = {icon: 'pi pi-home', routerLink: '/'};
        super.ngOnInit();
        this.initComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();

    }

    /**
     * Refresh Component.
     */
    refreshComponent() {

        this.getTotalRegistrations();
        this.refreshRegistrationHistoryWidget();
        this.refreshRegistrationGroupByGenderWidget();
        this.refreshRegistrationGroupByStatusWidget();
        this.refreshAddedRegistrations();
        this.initialized = true;
    }

    navigateToConfig() {
        this.router.navigate(['/eu/config']);
    }


    getTotalRegistrations() {

        const objectRequestList = ObjectRequestListGroupBy.create(
            false,
            this.filterCriteria,
            [],
            ['registrationStatusInternal'],
            [new ObjectRequestListAttribute('registrationStatusInternal', "Anzahl", DtoListAttributeRequestAggregateEnum.count)],
            ObjectRequestEntityProcessingTypeEnum.regular
        );

        this.registrationService.groupBy(objectRequestList).subscribe(res => {
            this.overviewDto = [
                {label: 'Pending Registrations', value: 0 },
                {label: 'Processed Registrations', value: 0 },
                {label: 'In-Process Registrations', value: 0 },
                {label: 'Unfinished Registrations', value: 0 }
            ];

            for (let entry of res.entries) {
                if (entry['registrationStatusInternal'] === EuRegistrationStatusInternal.pending) {
                    this.overviewDto.find(item => item.label === 'Pending Registrations').value = entry['registrationStatusInternal_count'];
                } else if (entry['registrationStatusInternal'] === EuRegistrationStatusInternal.processed) {
                    this.overviewDto.find(item => item.label === 'Processed Registrations').value = entry['registrationStatusInternal_count'];
                } else if (entry['registrationStatusInternal'] === EuRegistrationStatusInternal.in_processing) {
                    this.overviewDto.find(item => item.label === 'In-Process Registrations').value = entry['registrationStatusInternal_count'];
                } else if (entry['registrationStatusInternal'] === EuRegistrationStatusInternal.unfinished_closed) {
                    this.overviewDto.find(item => item.label === 'Unfinished Registrations').value = entry['registrationStatusInternal_count'];
                }
            }


        });
    }


    refreshRegistrationHistoryWidget() {
        this.registrationHistoryWidget = WidgetFactory.createWidget(
            'eu.registration.overview.history.widget',
            'Registrierungshistorie',
            'history.chart',
            'list',
            'entity.groupBy',
            'eu.EuRegistration',
            WidgetDataParam.create("fieldCategory", "deviceType"),
            WidgetDataParam.create("fieldCategoryCount", "deviceType_count"),
            WidgetDataParam.create("historyPeriodMode", "month"),
            WidgetDataParam.create("fieldDate", "createdDate"),
            WidgetDataParam.create("selectionMode", "single"),
            WidgetDataParam.create("size", "S")
        );
        this.registrationHistoryWidget.dataProviderListRequest = ObjectRequestListGroupBy.create(
            true,
            this.filterCriteria,
            [],
            ["deviceType", "createdDate"],
            [new ObjectRequestListAttribute("deviceType", "Type", DtoListAttributeRequestAggregateEnum.count)]
        );
    }

    refreshRegistrationGroupByGenderWidget() {
        this.registrationGroupByGenderWidget = WidgetFactory.createWidgetGroupBy(
            'eu.overview.registration.gender.widget',
            'Registration By Gender',
            'category',
            'entity.groupBy',
            'eu.EuRegistration',
            'gender',
            'gender_count',
            this.filterCriteria,
            'gender',
            'Anzahl');
    }

    refreshRegistrationGroupByStatusWidget() {
        this.registrationGroupByStatusWidget = WidgetFactory.createWidgetGroupBy(
            'eu.overview.registration.status.widget',
            'Registration By Status',
            'category',
            'entity.groupBy',
            'eu.EuRegistration',
            'registrationStatusInternal',
            'registrationStatusInternal_count',
            this.filterCriteria,
            'registrationStatusInternal',
            'Anzahl');
    }

    refreshAddedRegistrations() {
        this.recentlyAddedRegistrationsWidget = WidgetFactory.createWidgetTableEntityBasicQl('eu.overview.recently.added.registrations', 'Recent Registrations', 'eu.EuRegistration', this.filterCriteriaForQuery, [new Sorting('e.createdDate', false)]);
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
